import React, { useState, useEffect, useCallback } from 'react'
import { Accordion, Button, Col, Container, Form, Row } from 'react-bootstrap'
import { useCookies } from 'react-cookie'
import lang from '../../config/translate.json'
import WebPage from '../_webpage'
import Header from '../../components/header'
import Footer from '../../components/footer'
import * as httpServices from '../../services/http-services'
import {
  GoogleReCaptcha,
  GoogleReCaptchaProvider,
} from 'react-google-recaptcha-v3'


const FormAppealPage = () => {
  const [cookies, setCookies] = useCookies(['textSize', 'colorMode', 'language', 'subdomain', 'cookie_accepted', 'showEntersite', 'siteId'])

  const [pageData, setPageData] = useState({})
  const [token, setToken] = useState()
  const [refreshReCaptcha, setRefreshReCaptcha] = useState(false)
  const [form_data, setFormData] = useState(
    {
      "site_id": 1,
      "type": "appeal",
      "forms": [
        {
          "name": "name",
          "title": "ชื่อนามสกุล",
          "as": "input"
        },
        {
          "name": "email",
          "title": "อีเมล",
          "as": "input"
        },
        {
          "name": "tel",
          "title": "เบอร์โทรศัพท์ติดต่อกลับ",
          "as": "input"
        },
        {
          "name": "topic",
          "title": "ชื่อเรื่องประเด็นที่ร้องเรียน",
          "as": "input"
        },
        {
          "name": "detail",
          "title": "รายละเอียดที่ร้องเรียน",
          "as": "textarea"
        }
      ]
    }
  )

  const handleVerifyRecaptcha = useCallback((token) => {
    setToken(token)
  }, [])

  const postQuestion = (e) => {
    e.preventDefault()
    let formData = {}
    let notValidated = false
    form_data.forms.forEach((formField) => {
      const fieldValue = document.getElementById(formField.name).value
      formData[formField.name] = fieldValue
      if (fieldValue === '' || fieldValue === undefined) {
        notValidated = true
      }
    })
    formData['site_id'] = cookies.siteId
    formData['type'] = 'appeal'
    if (!notValidated) {
      httpServices.postComment(formData).then((response) => {
        console.log(response.data)
        if (response.data.success) {
          alert('ส่งร้องเรียน / ร้องทุกข์สำเร็จ')
          window.location.reload(false)
        }
      })
      setRefreshReCaptcha((r) => !r)
    } else {
      alert('กรุณากรอกให้ครบทุกข่อง')
    }
  }

  // const loadForm = () => {
  //   httpServices.getFormField()
  //     .then((response) => {
  //       let data = response.data
  //       let lstForm = []
  //       lstForm.map((item) => {
  //         lstForm.push({
  //           "site_id": item.site_id,
  //           "type": item.type,
  //           "forms": item.forms
  //         })
  //       })
  //       setFormData(lstForm)
  //     })
  // }

  useEffect(() => {
    //loadForm()
    // console.log(form_data)
  }, [cookies.language])

  return (
    <>
      <GoogleReCaptchaProvider reCaptchaKey="6Le7jzYnAAAAAJQ3ah0KeWPDbwa2gAoeulGf8-Yw">
        <WebPage

          mainComponents={
            <>
              <Header title={lang.appeal[cookies.language]} description={lang.appeal[cookies.language]} />
              <div>
                <div className={'breadcrumb-box-page-free'}>
                  <Container className="breadcrumb-text-box">
                    <a href={"/"}>{lang.home[cookies.language]}</a> / <a>{lang.appeal[cookies.language]}</a>
                  </Container>
                </div>
                <Container className="page-header-box">
                  <Row>
                    <Col xs="12">
                      <h2 className="news-section-header-with-line">{lang.appeal[cookies.language]}</h2>
                    </Col>
                    <Col xs="12" style={{ padding: '3rem' }}>
                      <Form>
                        {
                          form_data &&
                          form_data.forms.map((formField) => (
                            <Form.Group className='mb-3' key={formField.name}>
                              <Form.Control
                                id={formField.name}
                                placeholder={`กรุณากรอก ${formField.title}`}
                                as={formField.as}
                                required
                              />
                            </Form.Group>
                          ))
                        }
                        <GoogleReCaptcha action="homepage" onVerify={handleVerifyRecaptcha} />
                        <Button variant="primary" type="submit" onClick={postQuestion} disabled={!token}>
                          ส่ง
                        </Button>
                      </Form>
                    </Col>
                  </Row>
                </Container>
              </div>
              <Footer type={'form'} />
            </>
          }
        />
      </GoogleReCaptchaProvider>
    </>
  )
}

export default FormAppealPage
